// extracted by mini-css-extract-plugin
export default {"errorBoundaryTitle":"ErrorBoundary_errorBoundaryTitle__SYFcl","errorBoundaryMessage":"ErrorBoundary_errorBoundaryMessage__xy4+L"};